import { createReducer } from 'redux-act';
import actions from '../actions/leaveAction';

const initialState = {
    addLeaveTypePending: false,
    addLeaveTypeRes: null,
    addLeaveTypeError: null,

    getAllLeaveTypesPending: false,
    getAllLeaveTypesRes: null,
    getAllLeaveTypesError: null,

    updateLeaveTypePending: false,
    updateLeaveTypeRes: null,
    updateLeaveTypeError: null,

    deleteLeaveTypePending: false,
    deleteLeaveTypeRes: null,
    deleteLeaveTypeError: null,

    addLeaveSettingPending: false,
    addLeaveSettingRes: null,
    addLeaveSettingError: null,

    getAllLeaveSettingPending: false,
    getAllLeaveSettingRes: null,
    getAllLeaveSettingError: null,

    getLeaveSettingByLeaveIdPending: false,
    getLeaveSettingByLeaveIdRes: null,
    getLeaveSettingByLeaveIdError: null,

    updateLeaveSettingPending: false,
    updateLeaveSettingRes: null,
    updateLeaveSettingError: null,

    deleteLeaveSettingPending: false,
    deleteLeaveSettingRes: null,
    deleteLeaveSettingError: null,

    getLeaveConstantDataPending: false,
    getLeaveConstantDataRes: null,
    getLeaveConstantDataError: null,

    getLeaveTypeListPending: false,
    getLeaveTypeListRes: null,
    getLeaveTypeListError: null,

    applyLeavePending: false,
    applyLeaveRes: null,
    applyLeaveError: null,

    getLeaveBalancePending: false,
    getLeaveBalanceRes: null,
    getLeaveBalanceError: null,

    getEmpAppliedLeavePending: false,
    getEmpAppliedLeaveRes: null,
    getEmpAppliedLeaveError: null,

    approveRejectLeavePending: false,
    approveRejectLeaveRes: null,
    approveRejectLeaveError: null,

    cancelLeavePending: false,
    cancelLeaveRes: null,
    cancelLeaveError: null,

    getEmpApprovelLeavePending: false,
    getEmpApprovelLeaveRes: null,
    getEmpApprovelLeaveError: null,

    getAllEmployeeLeavePending: false,
    getAllEmployeeLeaveRes: null,
    getAllEmployeeLeaveError: null,

    getLeaveProgressPending: false,
    getLeaveProgressRes: null,
    getLeaveProgressError: null,

    sandwichLeavesDatesPending: false,
    sandwichLeavesDatesRes: null,
    sandwichLeavesDatesError: null,

    checkLeaveEncashmentFormulaPending: false,
    checkLeaveEncashmentFormulaRes: null,
    checkLeaveEncashmentFormulaError: null,

    creditDebitLeavePending: false,
    creditDebitLeaveRes: null,
    creditDebitLeaveError: null,

    getCreditDebitLeavePending: false,
    getCreditDebitLeaveRes: null,
    getCreditDebitLeaveError: null,

    getCompOffDataPending: false,
    getCompOffDataRes: null,
    getCompOffDataError: null,

    approveRejectCompOffPending: false,
    approveRejectCompOffRes: null,
    approveRejectCompOffError: null,

    applyTourPending: false,
    applyTourRes: null,
    applyTourError: null,

    getTourDataPending: false,
    getTourDataRes: null,
    getTourDataError: null,


    getTourApprovalPending: false,
    getTourApprovalRes: null,
    getTourApprovalError: null,

    approveRejectTourPending: false,
    approveRejectTourRes: null,
    approveRejectTourError: null,

    getLeaveTodayPending: false,
    getLeaveTodayRes: null,
    getLeaveTodayError: null,

    getEmployeeLeavePending: false,
    getEmployeeLeaveRes: null,
    getEmployeeLeaveError: null,

    getLeaveLedgerPending: false,
    getLeaveLedgerRes: null,
    getLeaveLedgerError: null,

    getLeaveLedgerReportPending: false,
    getLeaveLedgerReportRes: null,
    getLeaveLedgerReportError: null



};
/* Add Leave Type Reducers */
const handleAddLeaveTypeRequest = state => {
    return {
        ...state,
        ...{
            addLeaveTypePending: true,
            addLeaveTypeRes: null,
            addLeaveTypeError: null,
        },
    };
};
const handleAddLeaveTypeSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            addLeaveTypePending: false,
            addLeaveTypeRes: payload,
            addLeaveTypeError: null,
        },
    };
};
const handleAddLeaveTypeError = (state, payload) => ({
    ...state,
    ...{
        addLeaveTypePending: false,
        addLeaveTypeRes: null,
        addLeaveTypeError: payload,
    },
});


/* get AllLeaveTypes Reducers */
const handleGetAllLeaveTypesRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllLeaveTypesPending: true,
            getAllLeaveTypesRes: null,
            getAllLeaveTypesError: null,
        },
    };
};
const handleGetAllLeaveTypesSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllLeaveTypesPending: false,
            getAllLeaveTypesRes: payload,
            getAllLeaveTypesError: null,
        },
    };
};
const handleGetAllLeaveTypesError = (state1, payload) => ({
    ...state1,
    ...{
        getAllLeaveTypesPending: false,
        getAllLeaveTypesRes: null,
        getAllLeaveTypesError: payload,
    },
});

/* Update LeaveType List Reducers */
const handleUpdateLeaveTypeRequest = state1 => {
    return {
        ...state1,
        ...{
            updateLeaveTypePending: true,
            updateLeaveTypeRes: null,
            updateLeaveTypeError: null,
        },
    };
};
const handleUpdateLeaveTypeSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateLeaveTypePending: false,
            updateLeaveTypeRes: payload,
            updateLeaveTypeError: null,
        },
    };
};
const handleUpdateLeaveTypeError = (state1, payload) => ({
    ...state1,
    ...{
        updateLeaveTypePending: false,
        updateLeaveTypeRes: null,
        updateLeaveTypeError: payload,
    },
});

/* Delete Leave Type */
const handleDeleteLeaveTypeRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteLeaveTypePending: true,
            deleteLeaveTypeRes: null,
            deleteLeaveTypeError: null,
        },
    };
};
const handleDeleteLeaveTypeSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteLeaveTypePending: false,
            deleteLeaveTypeRes: payload,
            deleteLeaveTypeError: null,
        },
    };
};
const handleDeleteLeaveTypeError = (state1, payload) => ({
    ...state1,
    ...{
        deleteLeaveTypePending: false,
        deleteLeaveTypeRes: null,
        deleteLeaveTypeError: payload,
    },
});

/* Add LeaveSetting Reducer */
const handleAddLeaveSettingRequest = state1 => {
    return {
        ...state1,
        ...{
            addLeaveSettingPending: true,
            addLeaveSettingRes: null,
            addLeaveSettingError: null,
        },
    };
};
const handleAddLeaveSettingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            addLeaveSettingPending: false,
            addLeaveSettingRes: payload,
            addLeaveSettingError: null,
        },
    };
};
const handleAddLeaveSettingError = (state1, payload) => ({
    ...state1,
    ...{
        addLeaveSettingPending: false,
        addLeaveSettingRes: null,
        addLeaveSettingError: payload,
    },
});

/* Get All Leave Setting Reducer */
const handleGetAllLeaveSettingRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllLeaveSettingPending: true,
            getAllLeaveSettingRes: null,
            getAllLeaveSettingError: null,
        },
    };
};
const handleGetAllLeaveSettingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllLeaveSettingPending: false,
            getAllLeaveSettingRes: payload,
            getAllLeaveSettingError: null,
        },
    };
};
const handleGetAllLeaveSettingError = (state1, payload) => ({
    ...state1,
    ...{
        getAllLeaveSettingPending: false,
        getAllLeaveSettingRes: null,
        getAllLeaveSettingError: payload,
    },
});

/* Get Leave Setting By Leave Id Reducer */
const handleGetLeaveSettingByLeaveIdRequest = state1 => {
    return {
        ...state1,
        ...{
            getLeaveSettingByLeaveIdPending: true,
            getLeaveSettingByLeaveIdRes: null,
            getLeaveSettingByLeaveIdError: null,
        },
    };
};
const handleGetLeaveSettingByLeaveIdSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getLeaveSettingByLeaveIdPending: false,
            getLeaveSettingByLeaveIdRes: payload,
            getLeaveSettingByLeaveIdError: null,
        },
    };
};
const handleGetLeaveSettingByLeaveIdError = (state1, payload) => ({
    ...state1,
    ...{
        getLeaveSettingByLeaveIdPending: false,
        getLeaveSettingByLeaveIdRes: null,
        getLeaveSettingByLeaveIdError: payload,
    },
});

/* Get Update Leave Setting Reducer */
const handleUpdateLeaveSettingRequest = state1 => {
    return {
        ...state1,
        ...{
            updateLeaveSettingPending: true,
            updateLeaveSettingRes: null,
            updateLeaveSettingError: null,
        },
    };
};
const handleUpdateLeaveSettingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateLeaveSettingPending: false,
            updateLeaveSettingRes: payload,
            updateLeaveSettingError: null,
        },
    };
};
const handleUpdateLeaveSettingError = (state1, payload) => ({
    ...state1,
    ...{
        updateLeaveSettingPending: false,
        updateLeaveSettingRes: null,
        updateLeaveSettingError: payload,
    },
});

/* Get Update Leave Setting Reducer */
const handleDeleteLeaveSettingRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteLeaveSettingPending: true,
            deleteLeaveSettingRes: null,
            deleteLeaveSettingError: null,
        },
    };
};
const handleDeleteLeaveSettingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteLeaveSettingPending: false,
            deleteLeaveSettingRes: payload,
            deleteLeaveSettingError: null,
        },
    };
};
const handleDeleteLeaveSettingError = (state1, payload) => ({
    ...state1,
    ...{
        deleteLeaveSettingPending: false,
        deleteLeaveSettingRes: null,
        deleteLeaveSettingError: payload,
    },
});

/* Get Leave Constant Data Reducer */
const handleGetLeaveConstantDataRequest = state1 => {
    return {
        ...state1,
        ...{
            getLeaveConstantDataPending: true,
            getLeaveConstantDataRes: null,
            getLeaveConstantDataError: null,
        },
    };
};
const handleGetLeaveConstantDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getLeaveConstantDataPending: false,
            getLeaveConstantDataRes: payload,
            getLeaveConstantDataError: null,
        },
    };
};
const handleGetLeaveConstantDataError = (state1, payload) => ({
    ...state1,
    ...{
        getLeaveConstantDataPending: false,
        getLeaveConstantDataRes: null,
        getLeaveConstantDataError: payload,
    },
});

/* Get Get Leave Type List Reducer */
const handleGetLeaveTypeListRequest = state1 => {
    return {
        ...state1,
        ...{
            getLeaveTypeListPending: true,
            getLeaveTypeListRes: null,
            getLeaveTypeListError: null,
        },
    };
};
const handleGetLeaveTypeListSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getLeaveTypeListPending: false,
            getLeaveTypeListRes: payload,
            getLeaveTypeListError: null,
        },
    };
};
const handleGetLeaveTypeListError = (state1, payload) => ({
    ...state1,
    ...{
        getLeaveTypeListPending: false,
        getLeaveTypeListRes: null,
        getLeaveTypeListError: payload,
    },
});


// Apply Leave Reducers
const handleApplyLeaveRequest = state => {
    return {
        ...state,
        ...{
            applyLeavePending: true,
            applyLeaveRes: null,
            applyLeaveError: null,
        },
    };
};
const handleApplyLeaveSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            applyLeavePending: false,
            applyLeaveRes: payload,
            applyLeaveError: null,
        },
    };
};
const handleApplyLeaveError = (state, payload) => ({
    ...state,
    ...{
        applyLeavePending: false,
        applyLeaveRes: null,
        applyLeaveError: payload,
    },
});

// Get Leave Balance Reducers
const handleGetLeaveBalanceRequest = state => {
    return {
        ...state,
        ...{
            getLeaveBalancePending: true,
            getLeaveBalanceRes: null,
            getLeaveBalanceError: null,
        },
    };
};
const handleGetLeaveBalanceSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getLeaveBalancePending: false,
            getLeaveBalanceRes: payload,
            getLeaveBalanceError: null,
        },
    };
};
const handleGetLeaveBalanceError = (state, payload) => ({
    ...state,
    ...{
        getLeaveBalancePending: false,
        getLeaveBalanceRes: null,
        getLeaveBalanceError: payload,
    },
});

// Get Employee Applied Leave
const handleGetEmpAppliedLeaveRequest = state => {
    return {
        ...state,
        ...{
            getEmpAppliedLeavePending: true,
            getEmpAppliedLeaveRes: null,
            getEmpAppliedLeaveError: null,
        },
    };
};
const handleGetEmpAppliedLeaveSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getEmpAppliedLeavePending: false,
            getEmpAppliedLeaveRes: payload,
            getEmpAppliedLeaveError: null,
        },
    };
};
const handleGetEmpAppliedLeaveError = (state, payload) => ({
    ...state,
    ...{
        getEmpAppliedLeavePending: false,
        getEmpAppliedLeaveRes: null,
        getEmpAppliedLeaveError: payload,
    },
});


const handleApproveRejectLeaveRequest = state => {
    return {
        ...state,
        ...{
            approveRejectLeavePending: true,
            approveRejectLeaveRes: null,
            approveRejectLeaveError: null,
        },
    };
};
const handleApproveRejectLeaveSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            approveRejectLeavePending: false,
            approveRejectLeaveRes: payload,
            approveRejectLeaveError: null,
        },
    };
};
const handleApproveRejectLeaveError = (state, payload) => ({
    ...state,
    ...{
        approveRejectLeavePending: false,
        approveRejectLeaveRes: null,
        approveRejectLeaveError: payload,
    },
});

// Cancel Leave Reducers
const handleCancelLeaveRequest = state => {
    return {
        ...state,
        ...{
            cancelLeavePending: true,
            cancelLeaveRes: null,
            cancelLeaveError: null,
        },
    };
};
const handleCancelLeaveSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            cancelLeavePending: false,
            cancelLeaveRes: payload,
            cancelLeaveError: null,
        },
    };
};
const handleCancelLeaveError = (state, payload) => ({
    ...state,
    ...{
        cancelLeavePending: false,
        cancelLeaveRes: null,
        cancelLeaveError: payload,
    },
});

// Approvel Leave Reducers
const handleGetEmpApprovelLeaveRequest = state => {
    return {
        ...state,
        ...{
            getEmpApprovelLeavePending: true,
            getEmpApprovelLeaveRes: null,
            getEmpApprovelLeaveError: null,

        },
    };
};
const handleGetEmpApprovelLeaveSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getEmpApprovelLeavePending: false,
            getEmpApprovelLeaveRes: payload,
            getEmpApprovelLeaveError: null,

        },
    };
};
const handleGetEmpApprovelLeaveError = (state, payload) => ({
    ...state,
    ...{
        getEmpApprovelLeavePending: false,
        getEmpApprovelLeaveRes: null,
        getEmpApprovelLeaveError: payload,

    },
});

//get All Employee Leave 
const handlegetAllEmployeeLeaveRequest = state => {
    return {
        ...state,
        ...{
            getAllEmployeeLeavePending: true,
            getAllEmployeeLeaveRes: null,
            getAllEmployeeLeaveError: null,
        },
    };
};
const handleAllEmployeeLeaveSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getAllEmployeeLeavePending: false,
            getAllEmployeeLeaveRes: payload,
            getAllEmployeeLeaveError: null,
        },
    };
};
const handleAllEmployeeLeaveError = (state, payload) => ({
    ...state,
    ...{
        getAllEmployeeLeavePending: false,
        getAllEmployeeLeaveRes: null,
        getAllEmployeeLeaveError: payload,
    },
});


//get Leave Progress
const handleGetLeaveProgressRequest = state1 => {
    return {
        ...state1,
        ...{
            getLeaveProgressPending: true,
            getLeaveProgressRes: null,
            getLeaveProgressError: null,
        },
    };
};
const handleGetLeaveProgressSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getLeaveProgressPending: false,
            getLeaveProgressRes: payload,
            getLeaveProgressError: null,
        },
    };
};
const handleGetLeaveProgressError = (state1, payload) => ({
    ...state1,
    ...{
        getLeaveProgressPending: false,
        getLeaveProgressRes: null,
        getLeaveProgressError: payload,
    },
});

//get sandwich Leaves Dates
const handleSandwichLeavesDatesRequest = state1 => {
    return {
        ...state1,
        ...{
            sandwichLeavesDatesPending: true,
            sandwichLeavesDatesRes: null,
            sandwichLeavesDatesError: null,
        },
    };
};
const handleSandwichLeavesDatesSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            sandwichLeavesDatesPending: false,
            sandwichLeavesDatesRes: payload,
            sandwichLeavesDatesError: null,
        },
    };
};
const handleSandwichLeavesDatesError = (state1, payload) => ({
    ...state1,
    ...{
        sandwichLeavesDatesPending: false,
        sandwichLeavesDatesRes: null,
        sandwichLeavesDatesError: payload,
    },
});


/* check Leave Encashment Formula */
const handleCheckLeaveEncashmentFormulaRequest = state1 => {
    return {
        ...state1,
        ...{
            checkLeaveEncashmentFormulaPending: true,
            checkLeaveEncashmentFormulaRes: null,
            checkLeaveEncashmentFormulaError: null,
        },
    };
};
const handleCheckLeaveEncashmentFormulaSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            checkLeaveEncashmentFormulaPending: false,
            checkLeaveEncashmentFormulaRes: payload,
            checkLeaveEncashmentFormulaError: null,
        },
    };
};
const handleCheckLeaveEncashmentFormulaError = (state1, payload) => ({
    ...state1,
    ...{
        checkLeaveEncashmentFormulaPending: false,
        checkLeaveEncashmentFormulaRes: null,
        checkLeaveEncashmentFormulaError: payload,
    },
});


/* Credit Debit Leave Leaves Dates */
const handleCreditDebitLeaveRequest = state1 => {
    return {
        ...state1,
        ...{
            creditDebitLeavePending: true,
            creditDebitLeaveRes: null,
            creditDebitLeaveError: null,
        },
    };
};
const handleCreditDebitLeaveSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            creditDebitLeavePending: false,
            creditDebitLeaveRes: payload,
            creditDebitLeaveError: null,
        },
    };
};
const handleCreditDebitLeaveError = (state1, payload) => ({
    ...state1,
    ...{
        creditDebitLeavePending: false,
        creditDebitLeaveRes: null,
        creditDebitLeaveError: payload,
    },
});

/*  Get Credit Debit Leave Leaves Dates */
const handleGetCreditDebitLeaveRequest = state1 => {
    return {
        ...state1,
        ...{
            getCreditDebitLeavePending: true,
            getCreditDebitLeaveRes: null,
            getCreditDebitLeaveError: null,
        },
    };
};
const handleGetCreditDebitLeaveSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getCreditDebitLeavePending: false,
            getCreditDebitLeaveRes: payload,
            getCreditDebitLeaveError: null,
        },
    };
};
const handleGetCreditDebitLeaveError = (state1, payload) => ({
    ...state1,
    ...{
        getCreditDebitLeavePending: false,
        getCreditDebitLeaveRes: null,
        getCreditDebitLeaveError: payload,
    },
});


/* get Comp Off Data */
const handleGetCompOffDataRequest = state1 => {
    return {
        ...state1,
        ...{
            getCompOffDataPending: true,
            getCompOffDataRes: null,
            getCompOffDataError: null,
        },
    };
};
const handleGetCompOffDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getCompOffDataPending: false,
            getCompOffDataRes: payload,
            getCompOffDataError: null,
        },
    };
};
const handleGetCompOffDataError = (state1, payload) => ({
    ...state1,
    ...{
        getCompOffDataPending: false,
        getCompOffDataRes: null,
        getCompOffDataError: payload,
    },
});

/* Approve Reject Comp Off */
const handleApproveRejectCompOffRequest = state1 => {
    return {
        ...state1,
        ...{
            approveRejectCompOffPending: true,
            approveRejectCompOffRes: null,
            approveRejectCompOffError: null,
        },
    };
};
const handleApproveRejectCompOffSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            approveRejectCompOffPending: false,
            approveRejectCompOffRes: payload,
            approveRejectCompOffError: null,
        },
    };
};
const handleApproveRejectCompOffError = (state1, payload) => ({
    ...state1,
    ...{
        approveRejectCompOffPending: false,
        approveRejectCompOffRes: null,
        approveRejectCompOffError: payload,
    },
});

/* Apply Tour */
const handleApplyTourRequest = state1 => {
    return {
        ...state1,
        ...{
            applyTourPending: true,
            applyTourRes: null,
            applyTourError: null,
        },
    };
};
const handleApplyTourSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            applyTourPending: false,
            applyTourRes: payload,
            applyTourError: null,
        },
    };
};
const handleApplyTourError = (state1, payload) => ({
    ...state1,
    ...{
        applyTourPending: false,
        applyTourRes: null,
        applyTourError: payload,
    },
});

/* Get Tour Data */
const handleGetTourDataRequest = state1 => {
    return {
        ...state1,
        ...{
            getTourDataPending: true,
            getTourDataRes: null,
            getTourDataError: null,
        },
    };
};
const handleGetTourDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getTourDataPending: false,
            getTourDataRes: payload,
            getTourDataError: null,
        },
    };
};
const handleGetTourDataError = (state1, payload) => ({
    ...state1,
    ...{
        getTourDataPending: false,
        getTourDataRes: null,
        getTourDataError: payload,
    },
});

/* Get Tour Data */
const handleGetTourApprovalRequest = state1 => {
    return {
        ...state1,
        ...{
            getTourApprovalPending: true,
            getTourApprovalRes: null,
            getTourApprovalError: null,
        },
    };
};
const handleGetTourApprovalSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getTourApprovalPending: false,
            getTourApprovalRes: payload,
            getTourApprovalError: null,
        },
    };
};
const handleGetTourApprovalError = (state1, payload) => ({
    ...state1,
    ...{
        getTourApprovalPending: false,
        getTourApprovalRes: null,
        getTourApprovalError: payload,
    },
});

/* Approve Reject Tour Data */
const handleApproveRejectTourRequest = state1 => {
    return {
        ...state1,
        ...{
            approveRejectTourPending: true,
            approveRejectTourRes: null,
            approveRejectTourError: null,
        },
    };
};
const handleApproveRejectTourSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            approveRejectTourPending: false,
            approveRejectTourRes: payload,
            approveRejectTourError: null,
        },
    };
};
const handleApproveRejectTourError = (state1, payload) => ({
    ...state1,
    ...{
        approveRejectTourPending: false,
        approveRejectTourRes: null,
        approveRejectTourError: payload,
    },
});

/* Get Leave Today Data */
const handleGetLeaveTodayRequest = state1 => {
    return {
        ...state1,
        ...{
            getLeaveTodayPending: true,
            getLeaveTodayRes: null,
            getLeaveTodayError: null,
        },
    };
};
const handleGetLeaveTodaySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getLeaveTodayPending: false,
            getLeaveTodayRes: payload,
            getLeaveTodayError: null,
        },
    };
};
const handleGetLeaveTodayError = (state1, payload) => ({
    ...state1,
    ...{
        getLeaveTodayPending: false,
        getLeaveTodayRes: null,
        getLeaveTodayError: payload,
    },
});

/* Get Employee Leave */
const handleGetEmployeeLeaveRequest = state1 => {
    return {
        ...state1,
        ...{
            getEmployeeLeavePending: true,
            getEmployeeLeaveRes: null,
            getEmployeeLeaveError: null,
        },
    };
};
const handleGetEmployeeLeaveSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getEmployeeLeavePending: false,
            getEmployeeLeaveRes: payload,
            getEmployeeLeaveError: null,
        },
    };
};
const handleGetEmployeeLeaveError = (state1, payload) => ({
    ...state1,
    ...{
        getEmployeeLeavePending: false,
        getEmployeeLeaveRes: null,
        getEmployeeLeaveError: payload,
    },
});


/* get Leave Ledger Reducers */
const handleGetLeaveLedgerRequest = state => {
    return {
        ...state,
        ...{
            getLeaveLedgerPending: true,
            getLeaveLedgerRes: null,
            getLeaveLedgerError: null
        },
    };
};
const handleGetLeaveLedgerSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getLeaveLedgerPending: false,
            getLeaveLedgerRes: payload,
            getLeaveLedgerError: null
        },
    };
};
const handleGetLeaveLedgerError = (state, payload) => ({
    ...state,
    ...{
        getLeaveLedgerPending: false,
        getLeaveLedgerRes: null,
        getLeaveLedgerError: payload
    },
});


/* get Leave Ledger Report Reducers */
const handleGetLeaveLedgerReportRequest = state => {
    return {
        ...state,
        ...{
            getLeaveLedgerReportPending: true,
            getLeaveLedgerReportRes: null,
            getLeaveLedgerReportError: null
        },
    };
};
const handleGetLeaveLedgerReportSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getLeaveLedgerReportPending: false,
            getLeaveLedgerReportRes: payload,
            getLeaveLedgerReportError: null
        },
    };
};
const handleGetLeaveLedgerReportError = (state, payload) => ({
    ...state,
    ...{
        getLeaveLedgerReportPending: false,
        getLeaveLedgerReportRes: null,
        getLeaveLedgerReportError: payload
    },
});
// Clear Leave Store Reducers */
const clearLeaveStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_ADD_LEAVE_TYPE_STORE':
            return {
                ...state,
                ...{
                    addLeaveTypePending: false,
                    addLeaveTypeRes: null,
                    addLeaveTypeError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_LEAVE_TYPE_STORE':
            return {
                ...state,
                ...{
                    updateLeaveTypePending: false,
                    updateLeaveTypeRes: null,
                    updateLeaveTypeError: null,

                },
            };
        case 'HANDLE_CLEAR_DELETE_LEAVE_TYPE_STORE':
            return {
                ...state,
                ...{
                    deleteLeaveTypePending: false,
                    deleteLeaveTypeRes: null,
                    deleteLeaveTypeError: null,
                },
            };

        case 'HANDLE_CLEAR_ADD_LEAVE_SETTING_STORE':
            return {
                ...state,
                ...{
                    addLeaveSettingPending: false,
                    addLeaveSettingRes: null,
                    addLeaveSettingError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_LEAVE_SETTING_STORE':
            return {
                ...state,
                ...{
                    updateLeaveSettingPending: false,
                    updateLeaveSettingRes: null,
                    updateLeaveSettingError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_LEAVE_SETTING_STORE':
            return {
                ...state,
                ...{
                    deleteLeaveSettingPending: false,
                    deleteLeaveSettingRes: null,
                    deleteLeaveSettingError: null,
                },
            };
        case 'HANDLE_CLEAR_APPLY_LEAVE_STORE':
            return {
                ...state,
                ...{
                    applyLeavePending: false,
                    applyLeaveRes: null,
                    applyLeaveError: null,
                },
            };
        case 'HANDLE_APPROVE_REJECT_LEAVE_STORE':
            return {
                ...state,
                ...{
                    approveRejectLeavePending: false,
                    approveRejectLeaveRes: null,
                    approveRejectLeaveError: null,
                },
            };
        case 'HANDLE_CANCEL_LEAVE_STORE':
            return {
                ...state,
                ...{
                    cancelLeavePending: false,
                    cancelLeaveRes: null,
                    cancelLeaveError: null,
                },
            };
        case 'HANDLE_SANDWICH_LEAVE_STORE':
            return {
                ...state,
                ...{
                    sandwichLeavesDatesPending: false,
                    sandwichLeavesDatesRes: null,
                    sandwichLeavesDatesError: null,
                },
            };
        case 'HANDLE_CLEAR_CHECK_LEAVE_ENCASHMENT_FORMULA_STORE':
            return {
                ...state,
                ...{
                    checkLeaveEncashmentFormulaPending: false,
                    checkLeaveEncashmentFormulaRes: null,
                    checkLeaveEncashmentFormulaError: null,
                },
            };
        case 'HANDLE_CREDIT_DEBIT_LEAVE_STORE':
            return {
                ...state,
                ...{
                    creditDebitLeavePending: false,
                    creditDebitLeaveRes: null,
                    creditDebitLeaveError: null,
                },
            };

        case 'HANDLE_CLEAR_APPROVE_REJECT_COMP_OFF_STORE':
            return {
                ...state,
                ...{
                    approveRejectCompOffPending: false,
                    approveRejectCompOffRes: null,
                    approveRejectCompOffError: null,
                },
            };
        case 'HANDLE_CLEAR_APPLY_TOUR_STORE':
            return {
                ...state,
                ...{
                    applyTourPending: false,
                    applyTourRes: null,
                    applyTourError: null,
                },
            };
        case 'HANDLE_CLEAR_APPROVE_REJECT_TOUR_STORE':
            return {
                ...state,
                ...{
                    approveRejectTourPending: false,
                    approveRejectTourRes: null,
                    approveRejectTourError: null,
                },
            };

        case 'HANDLE_CLEAR_Leave_REPORT_STORE':
            return {
                ...state,
                ...{
                    getLeaveLedgerReportPending: false,
                    getLeaveLedgerReportRes: null,
                    getLeaveLedgerReportError: null
                },
            };
        case 'HANDLE_CLEAR_LEAVE_PROGRESS_STORE':
            return {
                ...state,
                ...{
                    getLeaveProgressPending: false,
                    getLeaveProgressRes: null,
                    getLeaveProgressError: null,
                },
            };

        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.addLeaveTypeRequest]: handleAddLeaveTypeRequest,
        [actions.addLeaveTypeSuccess]: handleAddLeaveTypeSuccess,
        [actions.addLeaveTypeError]: handleAddLeaveTypeError,

        [actions.getAllLeaveTypesRequest]: handleGetAllLeaveTypesRequest,
        [actions.getAllLeaveTypesSuccess]: handleGetAllLeaveTypesSuccess,
        [actions.getAllLeaveTypesError]: handleGetAllLeaveTypesError,

        [actions.updateLeaveTypeRequest]: handleUpdateLeaveTypeRequest,
        [actions.updateLeaveTypeSuccess]: handleUpdateLeaveTypeSuccess,
        [actions.updateLeaveTypeError]: handleUpdateLeaveTypeError,

        [actions.deleteLeaveTypeRequest]: handleDeleteLeaveTypeRequest,
        [actions.deleteLeaveTypeSuccess]: handleDeleteLeaveTypeSuccess,
        [actions.deleteLeaveTypeError]: handleDeleteLeaveTypeError,

        [actions.addLeaveSettingRequest]: handleAddLeaveSettingRequest,
        [actions.addLeaveSettingSuccess]: handleAddLeaveSettingSuccess,
        [actions.addLeaveSettingError]: handleAddLeaveSettingError,

        [actions.getAllLeaveSettingRequest]: handleGetAllLeaveSettingRequest,
        [actions.getAllLeaveSettingSuccess]: handleGetAllLeaveSettingSuccess,
        [actions.getAllLeaveSettingError]: handleGetAllLeaveSettingError,

        [actions.getLeaveSettingByLeaveIdRequest]: handleGetLeaveSettingByLeaveIdRequest,
        [actions.getLeaveSettingByLeaveIdSuccess]: handleGetLeaveSettingByLeaveIdSuccess,
        [actions.getLeaveSettingByLeaveIdError]: handleGetLeaveSettingByLeaveIdError,

        [actions.updateLeaveSettingRequest]: handleUpdateLeaveSettingRequest,
        [actions.updateLeaveSettingSuccess]: handleUpdateLeaveSettingSuccess,
        [actions.updateLeaveSettingError]: handleUpdateLeaveSettingError,

        [actions.deleteLeaveSettingRequest]: handleDeleteLeaveSettingRequest,
        [actions.deleteLeaveSettingSuccess]: handleDeleteLeaveSettingSuccess,
        [actions.deleteLeaveSettingError]: handleDeleteLeaveSettingError,

        [actions.getLeaveConstantDataRequest]: handleGetLeaveConstantDataRequest,
        [actions.getLeaveConstantDataSuccess]: handleGetLeaveConstantDataSuccess,
        [actions.getLeaveConstantDataError]: handleGetLeaveConstantDataError,

        [actions.getLeaveTypeListRequest]: handleGetLeaveTypeListRequest,
        [actions.getLeaveTypeListSuccess]: handleGetLeaveTypeListSuccess,
        [actions.getLeaveTypeListError]: handleGetLeaveTypeListError,

        [actions.applyLeaveRequest]: handleApplyLeaveRequest,
        [actions.applyLeaveSuccess]: handleApplyLeaveSuccess,
        [actions.applyLeaveError]: handleApplyLeaveError,

        [actions.getLeaveBalanceRequest]: handleGetLeaveBalanceRequest,
        [actions.getLeaveBalanceSuccess]: handleGetLeaveBalanceSuccess,
        [actions.getLeaveBalanceError]: handleGetLeaveBalanceError,

        [actions.getEmployeeAppliedLeaveRequest]: handleGetEmpAppliedLeaveRequest,
        [actions.getEmployeeAppliedLeaveSuccess]: handleGetEmpAppliedLeaveSuccess,
        [actions.getEmployeeAppliedLeaveError]: handleGetEmpAppliedLeaveError,

        [actions.approveRejectLeaveRequest]: handleApproveRejectLeaveRequest,
        [actions.approveRejectLeaveSuccess]: handleApproveRejectLeaveSuccess,
        [actions.approveRejectLeaveError]: handleApproveRejectLeaveError,

        [actions.cancelLeaveRequest]: handleCancelLeaveRequest,
        [actions.cancelLeaveSuccess]: handleCancelLeaveSuccess,
        [actions.cancelLeaveError]: handleCancelLeaveError,

        [actions.getEmployeeApprovelLeaveRequest]: handleGetEmpApprovelLeaveRequest,
        [actions.getEmployeeApprovelLeaveSuccess]: handleGetEmpApprovelLeaveSuccess,
        [actions.getEmployeeApprovelLeaveError]: handleGetEmpApprovelLeaveError,

        [actions.getAllEmployeeLeaveRequest]: handlegetAllEmployeeLeaveRequest,
        [actions.getAllEmployeeLeaveSuccess]: handleAllEmployeeLeaveSuccess,
        [actions.getAllEmployeeLeaveError]: handleAllEmployeeLeaveError,

        [actions.getLeaveProgressRequest]: handleGetLeaveProgressRequest,
        [actions.getLeaveProgressSuccess]: handleGetLeaveProgressSuccess,
        [actions.getLeaveProgressError]: handleGetLeaveProgressError,

        [actions.sandwichLeavesDatesRequest]: handleSandwichLeavesDatesRequest,
        [actions.sandwichLeavesDatesSuccess]: handleSandwichLeavesDatesSuccess,
        [actions.sandwichLeavesDatesError]: handleSandwichLeavesDatesError,

        [actions.checkLeaveEncashmentFormulaRequest]: handleCheckLeaveEncashmentFormulaRequest,
        [actions.checkLeaveEncashmentFormulaSuccess]: handleCheckLeaveEncashmentFormulaSuccess,
        [actions.checkLeaveEncashmentFormulaError]: handleCheckLeaveEncashmentFormulaError,

        [actions.creditDebitLeaveRequest]: handleCreditDebitLeaveRequest,
        [actions.creditDebitLeaveSuccess]: handleCreditDebitLeaveSuccess,
        [actions.creditDebitLeaveError]: handleCreditDebitLeaveError,

        [actions.getCreditDebitLeaveRequest]: handleGetCreditDebitLeaveRequest,
        [actions.getCreditDebitLeaveSuccess]: handleGetCreditDebitLeaveSuccess,
        [actions.getCreditDebitLeaveError]: handleGetCreditDebitLeaveError,

        [actions.getCompOffDataRequest]: handleGetCompOffDataRequest,
        [actions.getCompOffDataSuccess]: handleGetCompOffDataSuccess,
        [actions.getCompOffDataError]: handleGetCompOffDataError,

        [actions.approveRejectCompOffRequest]: handleApproveRejectCompOffRequest,
        [actions.approveRejectCompOffSuccess]: handleApproveRejectCompOffSuccess,
        [actions.approveRejectCompOffError]: handleApproveRejectCompOffError,

        [actions.applyTourRequest]: handleApplyTourRequest,
        [actions.applyTourSuccess]: handleApplyTourSuccess,
        [actions.applyTourError]: handleApplyTourError,

        [actions.getTourDataRequest]: handleGetTourDataRequest,
        [actions.getTourDataSuccess]: handleGetTourDataSuccess,
        [actions.getTourDataError]: handleGetTourDataError,

        [actions.getTourApprovalRequest]: handleGetTourApprovalRequest,
        [actions.getTourApprovalSuccess]: handleGetTourApprovalSuccess,
        [actions.getTourApprovalError]: handleGetTourApprovalError,

        [actions.approveRejectTourRequest]: handleApproveRejectTourRequest,
        [actions.approveRejectTourSuccess]: handleApproveRejectTourSuccess,
        [actions.approveRejectTourError]: handleApproveRejectTourError,

        [actions.getLeaveTodayRequest]: handleGetLeaveTodayRequest,
        [actions.getLeaveTodaySuccess]: handleGetLeaveTodaySuccess,
        [actions.getLeaveTodayError]: handleGetLeaveTodayError,

        [actions.getEmployeeLeaveRequest]: handleGetEmployeeLeaveRequest,
        [actions.getEmployeeLeaveSuccess]: handleGetEmployeeLeaveSuccess,
        [actions.getEmployeeLeaveError]: handleGetEmployeeLeaveError,

        [actions.getLeaveLedgerRequest]: handleGetLeaveLedgerRequest,
        [actions.getLeaveLedgerSuccess]: handleGetLeaveLedgerSuccess,
        [actions.getLeaveLedgerError]: handleGetLeaveLedgerError,

        [actions.getLeaveLedgerReportRequest]: handleGetLeaveLedgerReportRequest,
        [actions.getLeaveLedgerReportSuccess]: handleGetLeaveLedgerReportSuccess,
        [actions.getLeaveLedgerReportError]: handleGetLeaveLedgerReportError,

        [actions.handleClearLeaveStore]: clearLeaveStore,
    },
    initialState,
);